import { StyledTh, StyledTr } from "src/styled";
import { v4 as uuidv4 } from "uuid";

interface IHeader {
  [x: string]: any;
  type?: string;
  name?: string;
  unit?: string;
  width?: string;
  now?: boolean;
  id?: string;
}

export const generateHeadersRow = (
  headers: IHeader[],
  isDynamic: boolean = false,
) => {
  const generatedHeaders = headers.map(header => {
    if ("cols" in header) {
      return generateHeader(header, header.cols.length);
    } else {
      return generateHeader(header, 1, 2);
    }
  });

  // eslint-disable-next-line array-callback-return
  const generatedSubHeaders = headers.map(header => {
    if (header.type === "split") {
      return header.cols.map((subHeader: any) => {
        return generateHeader(subHeader, subHeader.length);
      });
    }
  });

  return (
    <thead>
      <StyledTr>
        {generatedHeaders}
        {isDynamic && (
          <StyledTh style={{ width: "50px" }} rowSpan={2}>
            DEL
          </StyledTh>
        )}
      </StyledTr>
      <StyledTr>{generatedSubHeaders}</StyledTr>
    </thead>
  );
};

const generateHeader = (headerObj: any, colspan = 1, rowspan = 1) => {
  if (headerObj.hidden) {
    // dont show blank headers if set to hidden
    return (
      <StyledTh
        colSpan={colspan}
        rowSpan={rowspan}
        key={uuidv4()}
        style={{
          height: "0px",
          margin: "0px",
          padding: "0px",
          border: "none",
        }}></StyledTh>
    );
  }
  return (
    <StyledTh colSpan={colspan} rowSpan={rowspan} key={uuidv4()}>
      {headerObj.name}
    </StyledTh>
  );
};
